import React from 'react';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

const CAREGIVER_CLAIMS_URL =
  '/health-care/file-travel-pay-reimbursement/caregiver-claims';

const App = () => {
  const { useToggleValue, useToggleLoadingValue, TOGGLE_NAMES } =
    useFeatureToggle();
  const togglesLoading = useToggleLoadingValue();
  const isCaregiverFilingEnabled = useToggleValue(
    TOGGLE_NAMES.travelPayEnableCaregiverFiling,
  );

  if (togglesLoading) {
    return null;
  }

  if (!isCaregiverFilingEnabled) {
    return (
      <>
        <p>
          Go to the Beneficiary Travel Self-Service System (BTSSS) to file your
          travel reimbursement claim online.
        </p>
        <va-link
          data-testid="btsss-link"
          href="https://dvagov-btsss.dynamics365portals.us/"
          text="Go to the BTSSS website"
        />
      </>
    );
  }

  return (
    <>
      <p>
        If you are the primary or secondary caregiver of a Veteran, you may be
        eligible for travel pay.
      </p>
      <va-link-action
        type="secondary"
        data-testid="caregiver-file-claim-link"
        href={`${CAREGIVER_CLAIMS_URL}/introduction/`}
        text="Start a travel reimbursement claim as a caregiver"
      />
      <p>
        <strong>Note:</strong> If you are filing as the caregiver, the
        deductible will be waived. Before you file, you will need to have the
        Veteran’s appointment information on hand as you will need to enter it
        to start a claim.
      </p>
      <p>
        Or you can check the status of all your travel reimbursement claims.
      </p>
      <va-link
        data-testid="caregiver-review-claims-link"
        href={`${CAREGIVER_CLAIMS_URL}/your-claims/`}
        text="Review travel reimbursement claims you filed as a caregiver"
      />
    </>
  );
};

export default App;
